import React from 'react';
const comparisonRows = [{
  situation: 'Tu cobro',
  without: 'Por sesión, irregular',
  with: 'Abono mensual el día 1-5'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos desde el día 5'
}, {
  situation: 'Nuevas familias',
  without: 'Solo boca a boca',
  with: 'Sistema de admisión activo'
}, {
  situation: 'Informes',
  without: 'Sin plantilla, horas de trabajo',
  with: 'Reporte en 1 página en 5 min'
}, {
  situation: 'Tu Instagram',
  without: 'Sin estrategia',
  with: '30 días de contenido listo'
}, {
  situation: 'La familia que abandona',
  without: 'Sin sistema',
  with: 'Protocolo de re-enganche'
}, {
  situation: 'Tus honorarios',
  without: 'Los del mercado o menos',
  with: '30-50% más justificados'
}];
const blocks = [{
  emoji: '💰',
  title: 'Bloque 1 — El Abono Blindado',
  desc: 'Cobro mensual adelantado + reglamento + contrato listo.',
  span: false
}, {
  emoji: '📋',
  title: 'Bloque 2 — Informes Rápidos',
  desc: 'Frases clínicas copy/paste. Reporte en 1 página en 5 min.',
  span: false
}, {
  emoji: '📱',
  title: 'Bloque 3 — WhatsApp que Retiene',
  desc: 'Scripts de conversión + seguimiento semanal automático.',
  span: false
}, {
  emoji: '📸',
  title: 'Bloque 4 — Autoridad Digital',
  desc: '20 tipos de post + calendario de 30 días listo.',
  span: false
}, {
  emoji: '📊',
  title: 'Assets incluidos:',
  desc: 'Planilla de Pagos · Calculadora de Honorarios · Reglamento · Contrato · Consentimiento · Autorización de Imagen · 20 Stories',
  span: true
}];
export function ProBusiness() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(240, 249, 255)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-227">
      <div className="mx-auto max-w-4xl" data-id="element-228">
        {/* Header */}
        <div className="mb-8 text-center" data-id="element-229">
          <h2 className="font-black text-gray-900 m-0 mb-3 text-[26px]" data-id="element-230">
            🏆 ¿QUÉ AGREGA EL{' '}
            <span className="text-cyan-brand" data-id="element-231">GABINETE DIGITAL 360™</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-600 m-0" data-id="element-232">
            El sistema de cobro, gestión e identidad profesional que hace que tu
            práctica esté a la altura de tu formación.
          </p>
        </div>

        {/* Comparison Table */}
        {/* Swipe hint for mobile */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-233">
          <span data-id="element-234">👆</span> Deslizá para ver la tabla completa
        </p>
        <div className="mb-10 overflow-x-auto bg-white border border-cyan-brand/30 rounded-xl shadow-sm touch-pan-x" style={{
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-235">
          <div className="min-w-[600px]" data-id="element-236">
            {/* Table Header */}
            <div className="grid grid-cols-3" style={{
            backgroundColor: 'rgb(248, 250, 252)'
          }} data-id="element-237">
              <div className="p-3 text-sm font-bold text-gray-900" data-id="element-238">
                Situación
              </div>
              <div className="p-3 text-center text-sm font-bold text-gray-500 border-l border-cyan-brand/30" data-id="element-239">
                Sin Gabinete Digital 360
              </div>
              <div className="p-3 text-center text-sm font-bold text-cyan-brand border-l border-cyan-brand/30" data-id="element-240">
                Con Gabinete Digital 360
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-241">
                <div className="p-3 text-xs sm:text-sm text-gray-900" data-id="element-242">
                  {row.situation}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-600 border-l border-gray-200 bg-gray-50" data-id="element-243">
                  {row.without}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-900 border-l border-gray-200 bg-cyan-brand/5" data-id="element-244">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Includes Section */}
        <h3 className="text-xl font-black text-center text-gray-900 m-0 mb-6" data-id="element-245">
          ✅ GABINETE DIGITAL 360™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-246">
          {blocks.map(block => <div key={block.title} className={`bg-white border border-cyan-brand/20 rounded-lg p-4 shadow-sm ${block.span ? 'md:col-span-2' : ''}`} data-id="element-247">
              <h4 className="text-base font-bold text-cyan-brand m-0 mb-1" data-id="element-248">
                {block.emoji} {block.title}
              </h4>
              <p className="text-xs text-gray-600 m-0" data-id="element-249">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}